import { call, put, takeLatest } from 'redux-saga/effects';
import request, { authRequest } from '../../helpers/request.helper';
import { authSuccessAction, authFailureAction } from '../actions/creators/auth.actioncreator';
import {
  AUTH_REQUEST,
} from '../actions/constants/auth.constants';
// import {
//   addNotificacion,
// } from '../actions/creators/sistemaNotificaciones/notificaciones.actioncreator';


function* authorize({ payload: { login, password, dominio } }) {
  const formData = new FormData();
  formData.append('username', login);
  formData.append('password', password);
  formData.append('tenant-dominio', dominio);
  formData.append('client_id', '3_98duj4rjcvwg8s0k8gsg0sw4kso0kcgs4sc4occggs0w800scg');
  formData.append('mostrar_permisos', true);
  const params = {
    url: 'public/login',
    method: 'POST',
    body: formData,
  };

  try {
    const { data } = yield call(request, params);
    const { access_token: accessToken } = data;
    localStorage.setItem('token', accessToken);
    const paramsPermisos = {
      url: 'configuracion/get',
      method: 'GET',
    };

    const { config } = yield call(authRequest, paramsPermisos);
    const { userInfo, Configuracion, Permiso } = config;
    // const { nc_lis: puedeListarNc } = Permiso;

    // if (!puedeListarNc) {
    // yield (put(addNotificacion('No puede acceder a la App')));
    //   yield put(authFailureAction('No puede listar No Conformidades'));
    // } else {
    yield put(authSuccessAction(accessToken, userInfo, Permiso, Configuracion));
    // }
  } catch (error) {
    yield put(authFailureAction(error));
  }
}


function* authenticationRequest() {
  yield takeLatest(AUTH_REQUEST, authorize);
}

export default authenticationRequest;
